import { render, staticRenderFns } from "./now.view.vue?vue&type=template&id=67123e60&scoped=true"
import script from "./now.view.vue?vue&type=script&lang=ts"
export * from "./now.view.vue?vue&type=script&lang=ts"
import style0 from "./now.view.vue?vue&type=style&index=0&id=67123e60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67123e60",
  null
  
)

export default component.exports